import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import { apiRoutes } from "configs/apiRoutes";
import instance from "api/apiClient";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;

  searchId: string;
  handleSearchId: (e: string) => void;

  handleUpdateDocumentStatuses: (
    e: { value: string | number; label: string }[],
  ) => void;
  selectedDocumentStatuses: {
    value: string | number;
    label: string;
  }[];

  handleUpdateDocumentTypes: (
    e: { value: string | number; label: string }[],
  ) => void;
  selectedDocumentTypes: {
    value: string | number;
    label: string;
  }[];
  handleUpdateDocumentSides: (
    e: { value: string | number; label: string }[],
  ) => void;

  selectedDocumentSides: {
    value: string | number;
    label: string;
  }[];

  handleUpdateSources: (e: { value: string | number; label: string }[]) => void;

  selectedSources: {
    value: string | number;
    label: string;
  }[];

  handleApply: () => void;
}

const KycDocumentsFilter: React.FC<Props> = ({
  searchValue,
  handleSearch,

  searchId,
  handleSearchId,

  handleUpdateDocumentStatuses,
  selectedDocumentStatuses,

  handleUpdateDocumentTypes,
  selectedDocumentTypes,

  handleUpdateDocumentSides,
  selectedDocumentSides,

  handleUpdateSources,
  selectedSources,

  handleApply,
}) => {
  const { t } = useTranslation();

  const documentStatuses = [
    { value: "pending", label: "pending" },
    { value: "approved", label: "approved" },
    { value: "rejected", label: "rejected" },
  ];

  const documentTypes = [
    { value: "passport", label: "passport" },
    { value: "id_card", label: "id_card" },
    { value: "driver_license", label: "driver_license" },
  ];

  const documentSides = [
    { value: "front", label: "front" },
    { value: "back", label: "back" },
  ];

  const sources = [
    { value: "manual", label: "manual" },
    { value: "automatic", label: "automatic" },
  ];

  const handleApplyDocumentStatuses = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateDocumentStatuses(
      isDelete ? e : [...selectedDocumentStatuses, ...e],
    );
  };

  const handleApplyDocumentTypes = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateDocumentTypes(isDelete ? e : [...selectedDocumentTypes, ...e]);
  };

  const handleClearFilters = () => {
    handleSearchId("");
    handleUpdateDocumentStatuses([]);
    handleUpdateDocumentTypes([]);

    handleSearch("");
    handleUpdateDocumentSides([]);
    handleUpdateSources([]);
    handleApply();
  };

  const handleApplyDocumentSides = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateDocumentSides(isDelete ? e : [...selectedDocumentSides, ...e]);
  };

  const handleApplySources = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateSources(isDelete ? e : [...selectedSources, ...e]);
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApply}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("userEmail"),
          boxTitle: t("userEmail"),
          icon: gridIcon,
          inputValue: searchValue,
          setInputValue: handleSearch,
          inputType: "text",
        },
        {
          type: FilterItemTypes.input,
          title: t("userId"),
          boxTitle: t("userId"),
          icon: gridIcon,
          inputValue: searchId,
          setInputValue: handleSearchId,
          inputType: "number",
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("documentStatus"),
          boxTitle: t("documentStatus"),
          icon: gridIcon,
          itemsArray: documentStatuses,
          activeItems: selectedDocumentStatuses,
          handleApply: handleApplyDocumentStatuses,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("documentType"),
          boxTitle: t("documentType"),
          icon: gridIcon,
          itemsArray: documentTypes,
          activeItems: selectedDocumentTypes,
          handleApply: handleApplyDocumentTypes,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("documentSide"),
          boxTitle: t("documentSide"),
          icon: gridIcon,
          itemsArray: documentSides,
          activeItems: selectedDocumentSides,
          handleApply: handleApplyDocumentSides,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("source"),
          boxTitle: t("source"),
          icon: gridIcon,
          itemsArray: sources,
          activeItems: selectedSources,
          handleApply: handleApplySources,
        },
      ]}
    />
  );
};

export default KycDocumentsFilter;
